import React from 'react';
import styles from '../DataTablePanel/styles.css';
import GroupHighlightSelectField from '../GroupHighlightSelectField/index.jsx';
import { useTranslation } from 'react-i18next';

// Highlighter icon (Material Symbols format_ink_highlighter)
const HighlighterIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#1f1f1f">
		<path d="M80 0v-160h800V0H80Zm504-480L480-584 320-424l103 104 161-160Zm-47-160 103 103 160-159-104-104-159 160Zm-84-29 216 216-189 190q-24 24-56.5 24T367-263l-27 23H140l126-125q-24-24-25-57.5t23-57.5l189-189Zm0 0 187-187q24-24 56.5-24t56.5 24l104 103q24 24 24 56.5T857-640L669-453 453-669Z" />
	</svg>
);

// Sort icon (Material Symbols swap_vert)
const SortIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#1f1f1f">
		<path d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z" />
	</svg>
);

export default function BarChartPanel({ sortBySettings, sortDirectionSettings, groupHighlights, checkboxes }) {
	const { t } = useTranslation();
	const showSortingControls = Boolean(sortBySettings && sortDirectionSettings);

	return (
		<div className="idp-settings-advanced advanced-settings">
			<div className="idp-settings-advanced__col">
				<div className="idp-settings-advanced__section-title">
					<HighlighterIcon />
					<span className="idp-settings-advanced__heading">{t('Chart highlighting:')}</span>
				</div>
				<GroupHighlightSelectField
					groupHighlights={groupHighlights}
					containerClassName={styles.advancedSelectField}
					selectClassName={styles.advancedSelect}
				/>
				{checkboxes && checkboxes.length > 0 ? (
					<div>
						{checkboxes.map((checkbox, index) => (
							<label
								key={`${checkbox.text.split(' ').join('')}_${index}`}
								className="idp-advanced-control-row clickable_pointer"
							>
								<input
									type="checkbox"
									className="idp-advanced-control"
									onChange={(e) => {
										checkbox.onChange(e.target.checked);
									}}
									checked={checkbox.checked}
								/>
								{checkbox.text}
							</label>
						))}
					</div>
				) : null}
			</div>
			{showSortingControls ? (
				<div className="idp-settings-advanced__col">
					<div className="idp-settings-advanced__section-title">
						<SortIcon />
						<span className="idp-settings-advanced__heading">{t('Data sorting:')}</span>
					</div>
					<div className="idp-settings-advanced__sort-group">
						<label className={`idp-settings-advanced__sub-label reduced-size-label clickable_pointer`}>
							{sortBySettings.title}
						</label>
						<div className={`${styles.trendOptions} idp-advanced-option-group`}>
							{sortBySettings.options.map((option, index) => {
								return (
									<label
										key={`sort_by_${option.label.split(' ').join('')}_${index}`}
										className={`idp-advanced-control-row idp-advanced-radio-row clickable_pointer ${
											option.checked ? 'idp-advanced-radio-row--checked' : ''
										}`}
									>
										<input
											checked={option.checked}
											type="radio"
											className="idp-advanced-control"
											name="bar-chart-sort-direction"
											onChange={() => {
												if (option.checked) {
													return;
												}
												option.onClick();
											}}
										/>
										{option.label}
									</label>
								);
							})}
						</div>
					</div>
					<div className="idp-settings-advanced__sort-group">
						<label className={`idp-settings-advanced__sub-label reduced-size-label clickable_pointer`}>
							{sortDirectionSettings.title}
						</label>
						<div className={`${styles.trendOptions} idp-advanced-option-group`}>
							{sortDirectionSettings.options.map((option, index) => (
								<label
									key={`sort_direction_${option.label.split(' ').join('')}_${index}`}
									className={`idp-advanced-control-row idp-advanced-radio-row clickable_pointer ${
										option.checked ? 'idp-advanced-radio-row--checked' : ''
									}`}
								>
									<input
										checked={option.checked}
										type="radio"
										className="idp-advanced-control"
										name="bar-chart-sort-by"
										onChange={() => {
											if (option.checked) {
												return;
											}
											option.onClick();
										}}
									/>
									{option.label}
								</label>
							))}
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
}
